import React from 'react';

interface CardProps {
  title?: React.ReactNode;
  icon?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const Card = React.memo<CardProps>(({
  title,
  icon,
  children,
  className = ''
}) => {
  return (
    <div className={`card ${className}`}>
      {(title || icon) && (
        <div className="flex items-center space-x-4 space-x-reverse mb-4">
          {icon && <div className="text-primary">{icon}</div>}
          {title && (
            <h3 className="text-lg font-semibold">{title}</h3>
          )}
        </div>
      )}
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;

export { Card };